import { create } from "zustand"

const botStore = create((set) => ({
    bot: null,
    setBot: (bot) => set((state) => ({ ...state, bot: bot })),
}))

export default botStore
